module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Workspace.0dc520c5.jpg";